import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19443d80"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "modal_update_merchant_credit_notes",
  ref: "updateInvoiceRef",
  "aria-hidden": "true",
  class: "modal fade",
  tabindex: "-1"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-1400px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  id: "kt_modal_update_merchant_credit_notes_header",
  class: "modal-header"
}
const _hoisted_5 = { class: "fw-bolder" }
const _hoisted_6 = {
  class: "btn btn-icon btn-sm btn-active-icon-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = { class: "form-group mb-7" }
const _hoisted_12 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = { class: "form-group mb-7" }
const _hoisted_15 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_16 = { class: "col-md-6" }
const _hoisted_17 = { class: "form-group mb-7" }
const _hoisted_18 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_19 = { class: "col-md-6" }
const _hoisted_20 = { class: "form-group mb-7" }
const _hoisted_21 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_22 = { class: "col-md-6" }
const _hoisted_23 = { class: "form-group mb-7" }
const _hoisted_24 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_25 = { class: "col-md-6" }
const _hoisted_26 = { class: "form-group mb-7" }
const _hoisted_27 = { class: "only-read-input capitalize" }
const _hoisted_28 = { class: "col-md-6" }
const _hoisted_29 = { class: "form-group mb-7" }
const _hoisted_30 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_31 = { class: "col-md-6" }
const _hoisted_32 = { class: "form-group mb-7" }
const _hoisted_33 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_34 = { class: "col-md-12" }
const _hoisted_35 = { class: "form-group mb-6" }
const _hoisted_36 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_37 = { class: "card" }
const _hoisted_38 = { class: "card-header p-0 border-0" }
const _hoisted_39 = { class: "card-title align-items-start flex-column" }
const _hoisted_40 = { class: "card-toolbar" }
const _hoisted_41 = {
  class: "d-flex justify-content-end",
  "data-kt-customer-table-toolbar": "base"
}
const _hoisted_42 = ["disabled"]
const _hoisted_43 = { class: "svg-icon svg-icon-2" }
const _hoisted_44 = ["disabled"]
const _hoisted_45 = { class: "card-body p-0" }
const _hoisted_46 = { class: "table align-middle table-row-bordered fs-5 dataTable no-footer" }
const _hoisted_47 = { class: "text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_48 = { class: "text-start" }
const _hoisted_49 = { class: "text-start" }
const _hoisted_50 = { class: "text-start" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "text-end" }, null, -1))
const _hoisted_52 = { class: "text-end" }
const _hoisted_53 = { class: "text-end" }
const _hoisted_54 = { class: "text-end" }
const _hoisted_55 = { class: "fw-semibold" }
const _hoisted_56 = { class: "text-start" }
const _hoisted_57 = { class: "w-200px" }
const _hoisted_58 = { class: "text-start" }
const _hoisted_59 = { class: "w-200px" }
const _hoisted_60 = { class: "text-start" }
const _hoisted_61 = { class: "w-60px" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "w-500px" })
], -1))
const _hoisted_63 = { class: "text-end" }
const _hoisted_64 = { key: 0 }
const _hoisted_65 = { class: "m-0 el-form-item__content" }
const _hoisted_66 = { key: 1 }
const _hoisted_67 = { class: "text-end text-nowrap" }
const _hoisted_68 = { class: "text-end" }
const _hoisted_69 = ["onClick"]
const _hoisted_70 = { class: "svg-icon svg-icon-3 icon-plus" }
const _hoisted_71 = { class: "svg-icon svg-icon-3 icon-minus" }
const _hoisted_72 = { class: "text-start" }
const _hoisted_73 = { class: "w-100 fs-5" }
const _hoisted_74 = { class: "d-flex align-items-center" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-50px me-sm-2" }, null, -1))
const _hoisted_76 = { class: "flex-fill overflow-hidden d-flex flex-column justify-content-center" }
const _hoisted_77 = { class: "mb-1 text-line-clamp-1" }
const _hoisted_78 = { class: "fs-6 text-gray-400" }
const _hoisted_79 = { class: "text-start" }
const _hoisted_80 = { class: "d-flex fs-5 flex-column" }
const _hoisted_81 = { class: "capitalize" }
const _hoisted_82 = { class: "fs-6" }
const _hoisted_83 = { class: "break-all text-gray-400" }
const _hoisted_84 = { colspan: "2" }
const _hoisted_85 = { class: "d-flex align-items-center justify-content-end" }
const _hoisted_86 = { class: "m-0 el-form-item__content" }
const _hoisted_87 = { class: "d-flex fs-5 flex-column" }
const _hoisted_88 = { class: "fs-6" }
const _hoisted_89 = { class: "break-all text-gray-400" }
const _hoisted_90 = { class: "d-flex align-items-center" }
const _hoisted_91 = { class: "m-0 el-form-item__content" }
const _hoisted_92 = { class: "el-input-group__append d-flex w-auto flex-center" }
const _hoisted_93 = { class: "d-flex fs-5 flex-column" }
const _hoisted_94 = { class: "fs-6" }
const _hoisted_95 = { class: "break-all text-gray-400" }
const _hoisted_96 = { class: "d-flex align-items-center" }
const _hoisted_97 = { class: "m-0 el-form-item__content" }
const _hoisted_98 = { class: "el-input-group__append d-flex w-auto flex-center" }
const _hoisted_99 = { class: "d-flex fs-5 flex-column" }
const _hoisted_100 = { class: "fs-6" }
const _hoisted_101 = { class: "break-all text-gray-400" }
const _hoisted_102 = { class: "m-0 el-form-item__content" }
const _hoisted_103 = { class: "el-input-group__append d-flex w-auto flex-center px-0" }
const _hoisted_104 = { class: "d-flex fs-5 flex-column" }
const _hoisted_105 = { class: "fs-6" }
const _hoisted_106 = { class: "break-all text-gray-400" }
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_108 = { class: "text-end text-nowrap" }
const _hoisted_109 = { class: "d-flex justify-content-end" }
const _hoisted_110 = ["onClick"]
const _hoisted_111 = { class: "svg-icon svg-icon-3" }
const _hoisted_112 = {
  class: "dataTables_empty py-10",
  colspan: "9"
}
const _hoisted_113 = { key: 0 }
const _hoisted_114 = {
  class: "align-top",
  colspan: "4"
}
const _hoisted_115 = { key: 0 }
const _hoisted_116 = { class: "d-flex flex-column gap-2" }
const _hoisted_117 = { class: "row" }
const _hoisted_118 = { class: "col-md-12" }
const _hoisted_119 = { class: "form-group d-flex flex-wrap" }
const _hoisted_120 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_121 = {
  class: "text-end align-baseline",
  colspan: "2"
}
const _hoisted_122 = { class: "d-flex flex-column gap-6" }
const _hoisted_123 = { class: "pt-3 text-nowrap" }
const _hoisted_124 = { key: 0 }
const _hoisted_125 = { class: "d-flex flex-column align-items-end" }
const _hoisted_126 = { class: "h-20px d-flex align-items-center text-gray-400 fs-7" }
const _hoisted_127 = { key: 1 }
const _hoisted_128 = { class: "d-flex flex-column align-items-end" }
const _hoisted_129 = { class: "h-20px d-flex align-items-center text-gray-400 fs-7" }
const _hoisted_130 = { class: "fs-4 fw-bold" }
const _hoisted_131 = { class: "text-end text-nowrap align-baseline" }
const _hoisted_132 = { class: "d-flex flex-column gap-6" }
const _hoisted_133 = { class: "pt-3" }
const _hoisted_134 = {
  key: 0,
  class: "d-flex align-items-center justify-content-end"
}
const _hoisted_135 = { class: "d-flex flex-column" }
const _hoisted_136 = { class: "d-flex align-items-center gap-2" }
const _hoisted_137 = {
  class: "svg-icon svg-icon-3 ms-2 me-0 cursor-pointer",
  "data-bs-target": "#modal_update_merchant_credit_notes_shipping_fee",
  "data-bs-toggle": "modal"
}
const _hoisted_138 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "h-20px d-flex align-items-center text-gray-400 fs-7" }, null, -1))
const _hoisted_139 = {
  key: 1,
  class: "d-flex align-items-center justify-content-end"
}
const _hoisted_140 = { class: "d-flex flex-column" }
const _hoisted_141 = { class: "d-flex align-items-center gap-2" }
const _hoisted_142 = {
  class: "svg-icon svg-icon-3 ms-2 me-0 cursor-pointer",
  "data-bs-target": "#modal_update_merchant_credit_notes_shipping_fee",
  "data-bs-toggle": "modal"
}
const _hoisted_143 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "h-20px d-flex align-items-center text-gray-400 fs-7" }, null, -1))
const _hoisted_144 = { class: "fs-4 fw-bold" }
const _hoisted_145 = { class: "modal-footer align-items-center justify-content-end" }
const _hoisted_146 = ["disabled"]
const _hoisted_147 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" }, null, -1))
const _hoisted_148 = { class: "svg-icon svg-icon-2" }
const _hoisted_149 = ["disabled"]
const _hoisted_150 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" }, null, -1))
const _hoisted_151 = { class: "svg-icon svg-icon-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_ElUploadList = _resolveComponent("ElUploadList")!
  const _component_product_info = _resolveComponent("product-info")!
  const _component_sku_info = _resolveComponent("sku-info")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_add_product = _resolveComponent("add-product")!
  const _component_update_shipping_fee = _resolveComponent("update-shipping-fee")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_form, {
          ref: "formRef",
          model: _ctx.formData,
          rules: _ctx.rules
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("h2", _hoisted_5, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.t("orderRequest.editInvoice")), 1),
                  _createElementVNode("span", {
                    class: _normalizeClass([_ctx.getMerchantOrderInvoiceStatus(_ctx.formData.status), "badge text-uppercase ms-2"])
                  }, _toDisplayString(_ctx.formData.__show.status), 3)
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("span", _hoisted_7, [
                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                  ])
                ])
              ]),
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.t("orderRequest.invoiceDate")), 1),
                      _createVNode(_component_el_form_item, { prop: "credit_note_date" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            modelValue: _ctx.formData.credit_note_date,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.credit_note_date) = $event)),
                            disabled: !_ctx.isEdit,
                            placeholder: _ctx.t('common.pickDate'),
                            class: "w-100",
                            format: "DD.MM.YYYY",
                            type: "date",
                            onChange: _cache[1] || (_cache[1] = ($event: any) => (
                        _ctx.commonChangeDefaultDate(
                          $event,
                          _ctx.formData,
                          'credit_note_date'
                        )
                      ))
                          }, null, 8, ["modelValue", "disabled", "placeholder"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.t("orderRequest.invoiceNumber")), 1),
                      _createVNode(_component_el_form_item, { prop: "credit_note_number" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.formData.credit_note_number,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.credit_note_number) = $event)),
                            modelModifiers: { trim: true },
                            disabled: !_ctx.isEdit,
                            placeholder: _ctx.t('common.plsEnter'),
                            clearable: "",
                            type: "text"
                          }, null, 8, ["modelValue", "disabled", "placeholder"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.t("order.totalAmount")), 1),
                      _createVNode(_component_el_form_item, { prop: "total_amount" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input_number, {
                            modelValue: _ctx.formData.total_amount,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.total_amount) = $event)),
                            controls: false,
                            min: 0,
                            precision: 2,
                            step: 0.01,
                            class: "w-100 text-start"
                          }, null, 8, ["modelValue", "step"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.t("orderRequest.externalOrderNumber")), 1),
                      _createVNode(_component_el_form_item, { prop: "external_order_number" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.formData.external_order_number,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.external_order_number) = $event)),
                            modelModifiers: { trim: true },
                            disabled: !_ctx.isEdit,
                            placeholder: _ctx.t('common.plsEnter'),
                            clearable: "",
                            type: "text"
                          }, null, 8, ["modelValue", "disabled", "placeholder"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.t("order.merchant")), 1),
                      _createVNode(_component_el_form_item, { prop: "merchant" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.formData.merchant,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.merchant) = $event)),
                            disabled: !_ctx.isEdit,
                            loading: _ctx.options.merchantLoading,
                            placeholder: _ctx.t('common.plsSelect'),
                            "remote-method": _ctx.searchMerchantSourceItems,
                            class: "w-100",
                            clearable: "",
                            filterable: "",
                            remote: "",
                            "remote-show-suffix": "",
                            onChange: _ctx.getSalesChannelsData
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.merchantOptions, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "disabled", "loading", "placeholder", "remote-method", "onChange"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("label", {
                        class: _normalizeClass([{
                      required: _ctx.formData.status === _ctx.InvoiceStatus.Checked,
                    }, "fs-6 fw-bold mb-2"])
                      }, _toDisplayString(_ctx.t("order.channel")), 3),
                      _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.formData.channel), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.t("merchantCreditNotes.accountingMonth")), 1),
                      _createVNode(_component_el_form_item, { prop: "accounting_month" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            modelValue: _ctx.formData.accounting_month,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.accounting_month) = $event)),
                            disabled: !_ctx.isEdit,
                            placeholder: _ctx.t('common.pickDate'),
                            class: "w-100",
                            format: "MM.YYYY",
                            type: "month",
                            "value-format": "YYYY-MM"
                          }, null, 8, ["modelValue", "disabled", "placeholder"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.t("merchantCreditNotes.type")), 1),
                      _createVNode(_component_el_form_item, { prop: "price_calc_mode" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.formData.price_calc_mode,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.price_calc_mode) = $event)),
                            disabled: !_ctx.isEdit,
                            placeholder: _ctx.t('common.plsSelect'),
                            class: "w-100",
                            clearable: ""
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.vatTypeOptions, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "disabled", "placeholder"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.t("orderRequest.invoiceFiles")), 1),
                      _createVNode(_component_el_form_item, { prop: "credit_note_file" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ElUploadList, {
                            ref: "elUploadListRef",
                            fileList: _ctx.fileList,
                            "onUpdate:fileList": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.fileList) = $event)),
                            data: _ctx.uploadData,
                            disabledClick: !_ctx.isEdit,
                            isShowRemoveAll: _ctx.isEdit,
                            multiple: false,
                            "upload-url": _ctx.uploadUrl,
                            accept: ".pdf",
                            onChangeFile: _ctx.fileChange,
                            onRemoveFile: _ctx.removeFile,
                            onRemoveFiles: _ctx.removeFiles,
                            onUploadStatusChange: _ctx.uploadStatusChange
                          }, null, 8, ["fileList", "data", "disabledClick", "isShowRemoveAll", "upload-url", "onChangeFile", "onRemoveFile", "onRemoveFiles", "onUploadStatusChange"])
                        ]),
                        _: 1
                      }),
                      _withDirectives(_createVNode(_component_el_form_item, { prop: "status" }, null, 512), [
                        [_vShow, 0]
                      ]),
                      _withDirectives(_createVNode(_component_el_form_item, { prop: "relation_credit_note_item" }, null, 512), [
                        [_vShow, 0]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("h3", null, _toDisplayString(_ctx.t("orderRequest.items")), 1)
                      ]),
                      _withDirectives(_createElementVNode("div", _hoisted_40, [
                        _createElementVNode("div", _hoisted_41, [
                          _createElementVNode("button", {
                            disabled: _ctx.formData.merchant === '',
                            class: "btn btn-light-primary",
                            "data-bs-target": "#modal_add_product",
                            "data-bs-toggle": "modal",
                            type: "button"
                          }, [
                            _createElementVNode("span", _hoisted_43, [
                              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr075.svg" })
                            ]),
                            _createTextVNode(" " + _toDisplayString(_ctx.t("orderRequest.addItem")), 1)
                          ], 8, _hoisted_42),
                          _createElementVNode("button", {
                            disabled: 
                          _ctx.formData.relation_credit_note_item.length === 0
                        ,
                            class: "btn btn-light-danger ms-2",
                            type: "button",
                            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.removeItems && _ctx.removeItems(...args)))
                          }, _toDisplayString(_ctx.t("orderRequest.itemsRemove")), 9, _hoisted_44)
                        ])
                      ], 512), [
                        [_vShow, _ctx.isEdit]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("table", _hoisted_46, [
                        _createElementVNode("thead", null, [
                          _createElementVNode("tr", _hoisted_47, [
                            _createElementVNode("th", _hoisted_48, _toDisplayString(_ctx.t("order.product")), 1),
                            _createElementVNode("th", _hoisted_49, _toDisplayString(_ctx.t("order.sku")), 1),
                            _createElementVNode("th", _hoisted_50, _toDisplayString(_ctx.t("order.qty")), 1),
                            _hoisted_51,
                            _createElementVNode("th", _hoisted_52, _toDisplayString(_ctx.t("order.tax")), 1),
                            _createElementVNode("th", _hoisted_53, _toDisplayString(_ctx.t("order.grandTotalBase")), 1),
                            _createElementVNode("th", _hoisted_54, _toDisplayString(_ctx.t("common.action")), 1)
                          ])
                        ]),
                        _createElementVNode("tbody", _hoisted_55, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.list, (item, index) => {
                            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                              _createElementVNode("tr", null, [
                                _createElementVNode("td", _hoisted_56, [
                                  _createElementVNode("div", _hoisted_57, [
                                    _createVNode(_component_product_info, {
                                      brand_id: item.__show.brand_name,
                                      gallery: [
                                  {
                                    id: 0,
                                    origin_url: item.__show.product_gallery,
                                  },
                                ],
                                      name: item.__show.product_name,
                                      name_en: item.__show.product_name,
                                      source_link: ''
                                    }, null, 8, ["brand_id", "gallery", "name", "name_en"])
                                  ])
                                ]),
                                _createElementVNode("td", _hoisted_58, [
                                  _createElementVNode("div", _hoisted_59, [
                                    _createVNode(_component_sku_info, {
                                      brand_article_no: item.__show.article_no,
                                      color: item.__show.color,
                                      product_identifier_id: 
                                  item.product_identifier_id
                                ,
                                      size: item.__show.size
                                    }, null, 8, ["brand_article_no", "color", "product_identifier_id", "size"])
                                  ])
                                ]),
                                _createElementVNode("td", _hoisted_60, [
                                  _createElementVNode("div", _hoisted_61, _toDisplayString(item.total_qty), 1)
                                ]),
                                _hoisted_62,
                                _createElementVNode("td", _hoisted_63, [
                                  (_ctx.isEdit)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                        _createElementVNode("div", _hoisted_65, [
                                          _createVNode(_component_el_select, {
                                            modelValue: item.tax_rate,
                                            "onUpdate:modelValue": ($event: any) => ((item.tax_rate) = $event),
                                            placeholder: _ctx.t('common.plsSelect'),
                                            class: "w-70px size-sm",
                                            onChange: ($event: any) => (_ctx.taxChange(item, index))
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_el_option, {
                                                label: '--',
                                                value: 0
                                              }),
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.__show.taxRates, (row) => {
                                                return (_openBlock(), _createBlock(_component_el_option, {
                                                  key: row,
                                                  label: row + '%',
                                                  value: row
                                                }, null, 8, ["label", "value"]))
                                              }), 128))
                                            ]),
                                            _: 2
                                          }, 1032, ["modelValue", "onUpdate:modelValue", "placeholder", "onChange"])
                                        ])
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_66, _toDisplayString(item.tax_rate + "%"), 1))
                                ]),
                                _createElementVNode("td", _hoisted_67, _toDisplayString(_ctx.$currency.currency(
                                item.total +
                                  (index === _ctx.options.list.length - 1
                                    ? _ctx.diffSubTotal
                                    : 0),
                                2,
                                ",",
                                ".",
                                "€ "
                              )), 1),
                                _createElementVNode("td", _hoisted_68, [
                                  _createElementVNode("button", {
                                    class: _normalizeClass([{ active: item.isExpand }, "btn btn-icon toggle-btn btn-bg-light btn-active-color-primary btn-sm"]),
                                    type: "button",
                                    onClick: ($event: any) => (_ctx.expandSub(item))
                                  }, [
                                    _createElementVNode("span", _hoisted_70, [
                                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr075.svg" })
                                    ]),
                                    _createElementVNode("span", _hoisted_71, [
                                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr090.svg" })
                                    ])
                                  ], 10, _hoisted_69)
                                ])
                              ]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.list, (row, key) => {
                                return _withDirectives((_openBlock(), _createElementBlock("tr", {
                                  key: key,
                                  class: "subtable_template text-start border-bordered"
                                }, [
                                  _createElementVNode("td", _hoisted_72, [
                                    _createElementVNode("div", _hoisted_73, [
                                      _createElementVNode("div", _hoisted_74, [
                                        _hoisted_75,
                                        _createElementVNode("div", _hoisted_76, [
                                          _createElementVNode("div", _hoisted_77, _toDisplayString(_ctx.formData.relation_credit_note_item[
                                          row.index
                                        ].request_number), 1),
                                          _createElementVNode("span", _hoisted_78, _toDisplayString(_ctx.formatDate(
                                        _ctx.formData.relation_credit_note_item[
                                          row.index
                                        ].request_date
                                      )), 1)
                                        ])
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("td", _hoisted_79, [
                                    _createElementVNode("div", _hoisted_80, [
                                      _createElementVNode("div", _hoisted_81, _toDisplayString(_ctx.formData.relation_credit_note_item[
                                      row.index
                                    ].__show.channel_name) + " " + _toDisplayString(_ctx.formData.relation_credit_note_item[
                                      row.index
                                    ].__show.channel_type), 1),
                                      _createElementVNode("div", _hoisted_82, [
                                        _createElementVNode("div", _hoisted_83, [
                                          _createElementVNode("span", null, _toDisplayString(_ctx.t("order.channel")), 1)
                                        ])
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("td", _hoisted_84, [
                                    _createElementVNode("div", {
                                      class: _normalizeClass(["d-flex align-items-center", {
                                  'gap-5': _ctx.isEdit,
                                  'gap-15': !_ctx.isEdit,
                                }])
                                    }, [
                                      _withDirectives(_createElementVNode("div", null, [
                                        _createElementVNode("div", _hoisted_85, [
                                          _createElementVNode("div", _hoisted_86, [
                                            _createVNode(_component_el_select, {
                                              modelValue: 
                                          _ctx.formData.relation_credit_note_item[
                                            row.index
                                          ].confirmed_qty
                                        ,
                                              "onUpdate:modelValue": ($event: any) => ((
                                          _ctx.formData.relation_credit_note_item[
                                            row.index
                                          ].confirmed_qty
                                        ) = $event),
                                              class: "w-70px size-sm label-on-top",
                                              placeholder: " ",
                                              style: _normalizeStyle({
                                          '--label': `'${_ctx.t('order.qty')}'`,
                                        })
                                            }, {
                                              default: _withCtx(() => [
                                                (
                                            _ctx.formData.relation_credit_note_item[
                                              row.index
                                            ].qty === 0
                                          )
                                                  ? (_openBlock(), _createBlock(_component_el_option, {
                                                      key: 0,
                                                      label: 0,
                                                      value: 0
                                                    }))
                                                  : _createCommentVNode("", true),
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData
                                            .relation_credit_note_item[
                                            row.index
                                          ].qty, (k, j) => {
                                                  return (_openBlock(), _createBlock(_component_el_option, {
                                                    key: j,
                                                    label: k,
                                                    value: k
                                                  }, null, 8, ["label", "value"]))
                                                }), 128))
                                              ]),
                                              _: 2
                                            }, 1032, ["modelValue", "onUpdate:modelValue", "style"])
                                          ])
                                        ])
                                      ], 512), [
                                        [_vShow, _ctx.isEdit]
                                      ]),
                                      _withDirectives(_createElementVNode("div", null, [
                                        _createElementVNode("div", _hoisted_87, [
                                          _createElementVNode("div", null, _toDisplayString(_ctx.formData.relation_credit_note_item[
                                          row.index
                                        ].qty), 1),
                                          _createElementVNode("div", _hoisted_88, [
                                            _createElementVNode("div", _hoisted_89, [
                                              _createElementVNode("span", null, _toDisplayString(_ctx.t("order.qty")), 1)
                                            ])
                                          ])
                                        ])
                                      ], 512), [
                                        [_vShow, !_ctx.isEdit]
                                      ]),
                                      _withDirectives(_createElementVNode("div", null, [
                                        _createElementVNode("div", _hoisted_90, [
                                          _createElementVNode("div", _hoisted_91, [
                                            _createElementVNode("div", {
                                              class: "d-flex el-input el-input-group--append el-input--suffix label-on-top",
                                              style: _normalizeStyle({
                                          '--label': `'${_ctx.t(
                                            'order.grossPrice'
                                          )}'`,
                                        })
                                            }, [
                                              _createVNode(_component_el_input_number, {
                                                modelValue: 
                                            _ctx.formData.relation_credit_note_item[
                                              row.index
                                            ].unit_gross_amount
                                          ,
                                                "onUpdate:modelValue": ($event: any) => ((
                                            _ctx.formData.relation_credit_note_item[
                                              row.index
                                            ].unit_gross_amount
                                          ) = $event),
                                                controls: false,
                                                min: 0,
                                                precision: 2,
                                                step: 0.01,
                                                class: "w-90px size-sm text-end",
                                                onChange: ($event: any) => (
                                            _ctx.priceChange(
                                              $event,
                                              'unit_gross_amount',
                                              row.index
                                            )
                                          )
                                              }, null, 8, ["modelValue", "onUpdate:modelValue", "step", "onChange"]),
                                              _createElementVNode("div", _hoisted_92, _toDisplayString(_ctx.formData.relation_credit_note_item[
                                              row.index
                                            ].currency == "CNY"
                                              ? "￥"
                                              : "€"), 1)
                                            ], 4)
                                          ])
                                        ])
                                      ], 512), [
                                        [_vShow, _ctx.isEdit]
                                      ]),
                                      _withDirectives(_createElementVNode("div", null, [
                                        _createElementVNode("div", _hoisted_93, [
                                          _createElementVNode("div", null, _toDisplayString(_ctx.$currency.currency(
                                          _ctx.formData.relation_credit_note_item[
                                            row.index
                                          ].unit_gross_amount,
                                          2,
                                          ",",
                                          ".",
                                          "€ "
                                        )), 1),
                                          _createElementVNode("div", _hoisted_94, [
                                            _createElementVNode("div", _hoisted_95, [
                                              _createElementVNode("span", null, _toDisplayString(_ctx.t("order.grossPrice")), 1)
                                            ])
                                          ])
                                        ])
                                      ], 512), [
                                        [_vShow, !_ctx.isEdit]
                                      ]),
                                      _withDirectives(_createElementVNode("div", null, [
                                        _createElementVNode("div", _hoisted_96, [
                                          _createElementVNode("div", _hoisted_97, [
                                            _createElementVNode("div", {
                                              class: "d-flex el-input el-input-group--append el-input--suffix label-on-top",
                                              style: _normalizeStyle({
                                          '--label': `'${_ctx.t('order.netPrice')}'`,
                                        })
                                            }, [
                                              _createVNode(_component_el_input_number, {
                                                modelValue: 
                                            _ctx.formData.relation_credit_note_item[
                                              row.index
                                            ].unit_net_amount
                                          ,
                                                "onUpdate:modelValue": ($event: any) => ((
                                            _ctx.formData.relation_credit_note_item[
                                              row.index
                                            ].unit_net_amount
                                          ) = $event),
                                                controls: false,
                                                min: 0,
                                                precision: 2,
                                                step: 0.01,
                                                class: "w-90px size-sm text-end",
                                                onChange: ($event: any) => (
                                            _ctx.priceChange(
                                              $event,
                                              'unit_net_amount',
                                              row.index
                                            )
                                          )
                                              }, null, 8, ["modelValue", "onUpdate:modelValue", "step", "onChange"]),
                                              _createElementVNode("div", _hoisted_98, _toDisplayString(_ctx.formData.relation_credit_note_item[
                                              row.index
                                            ].currency == "CNY"
                                              ? "￥"
                                              : "€"), 1)
                                            ], 4)
                                          ])
                                        ])
                                      ], 512), [
                                        [_vShow, _ctx.isEdit]
                                      ]),
                                      _withDirectives(_createElementVNode("div", null, [
                                        _createElementVNode("div", _hoisted_99, [
                                          _createElementVNode("div", null, _toDisplayString(_ctx.$currency.currency(
                                          _ctx.formData.relation_credit_note_item[
                                            row.index
                                          ].unit_net_amount,
                                          2,
                                          ",",
                                          ".",
                                          "€ "
                                        )), 1),
                                          _createElementVNode("div", _hoisted_100, [
                                            _createElementVNode("div", _hoisted_101, [
                                              _createElementVNode("span", null, _toDisplayString(_ctx.t("order.netPrice")), 1)
                                            ])
                                          ])
                                        ])
                                      ], 512), [
                                        [_vShow, !_ctx.isEdit]
                                      ]),
                                      _withDirectives(_createElementVNode("div", null, [
                                        _createElementVNode("div", _hoisted_102, [
                                          _createElementVNode("div", {
                                            class: "d-flex el-input el-input-group el-input-group--append el-input--suffix label-on-top",
                                            style: _normalizeStyle({
                                        '--label': `'${_ctx.t('order.discount')}'`,
                                      })
                                          }, [
                                            _createVNode(_component_el_input_number, {
                                              modelValue: 
                                          _ctx.formData.relation_credit_note_item[
                                            row.index
                                          ].discount
                                        ,
                                              "onUpdate:modelValue": ($event: any) => ((
                                          _ctx.formData.relation_credit_note_item[
                                            row.index
                                          ].discount
                                        ) = $event),
                                              controls: false,
                                              min: 0,
                                              precision: 2,
                                              step: 0.01,
                                              class: "w-90px size-sm text-end"
                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "step"]),
                                            _createElementVNode("div", _hoisted_103, [
                                              _createVNode(_component_el_select, {
                                                modelValue: 
                                            _ctx.formData.relation_credit_note_item[
                                              row.index
                                            ].discount_type
                                          ,
                                                "onUpdate:modelValue": ($event: any) => ((
                                            _ctx.formData.relation_credit_note_item[
                                              row.index
                                            ].discount_type
                                          ) = $event),
                                                placeholder: _ctx.t('common.plsSelect'),
                                                class: "w-50px size-sm"
                                              }, {
                                                default: _withCtx(() => [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.discount, (row) => {
                                                    return (_openBlock(), _createBlock(_component_el_option, {
                                                      key: row.value,
                                                      label: row.label,
                                                      value: row.value
                                                    }, null, 8, ["label", "value"]))
                                                  }), 128))
                                                ]),
                                                _: 2
                                              }, 1032, ["modelValue", "onUpdate:modelValue", "placeholder"])
                                            ])
                                          ], 4)
                                        ])
                                      ], 512), [
                                        [_vShow, _ctx.isEdit]
                                      ]),
                                      _withDirectives(_createElementVNode("div", null, [
                                        _createElementVNode("div", _hoisted_104, [
                                          _createElementVNode("div", null, _toDisplayString(_ctx.$currency.currency(
                                          _ctx.formData.relation_credit_note_item[
                                            row.index
                                          ].discount,
                                          2,
                                          ",",
                                          ".",
                                          ""
                                        )) + _toDisplayString(_ctx.formData.relation_credit_note_item[
                                          row.index
                                        ].discount_type === _ctx.CurrencyType.Amount
                                          ? "€"
                                          : "%"), 1),
                                          _createElementVNode("div", _hoisted_105, [
                                            _createElementVNode("div", _hoisted_106, [
                                              _createElementVNode("span", null, _toDisplayString(_ctx.t("order.discount")), 1)
                                            ])
                                          ])
                                        ])
                                      ], 512), [
                                        [_vShow, !_ctx.isEdit]
                                      ])
                                    ], 2)
                                  ]),
                                  _hoisted_107,
                                  _createElementVNode("td", _hoisted_108, _toDisplayString(_ctx.$currency.currency(
                                  _ctx.getOrderItemAmountTotal(
                                    _ctx.formData.relation_credit_note_item[
                                      row.index
                                    ].confirmed_qty,
                                    _ctx.getNetPrice(
                                      _ctx.formData.relation_credit_note_item[
                                        row.index
                                      ]
                                    ),
                                    _ctx.formData.relation_credit_note_item[
                                      row.index
                                    ].discount,
                                    _ctx.formData.relation_credit_note_item[
                                      row.index
                                    ].discount_type,
                                    _ctx.formData.relation_credit_note_item[
                                      row.index
                                    ].tax_rate,
                                    _ctx.isGrossCalculation
                                  ) +
                                    (index === _ctx.options.list.length - 1 &&
                                    key === item.list.length - 1
                                      ? _ctx.diffSubTotal
                                      : 0),
                                  2,
                                  ",",
                                  ".",
                                  "€ "
                                )), 1),
                                  _createElementVNode("td", null, [
                                    _createElementVNode("div", _hoisted_109, [
                                      _withDirectives(_createElementVNode("span", {
                                        class: "btn btn-sm btn-icon btn-light-danger",
                                        onClick: ($event: any) => (_ctx.removeItem(row.index))
                                      }, [
                                        _createElementVNode("span", _hoisted_111, [
                                          _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen027.svg" })
                                        ])
                                      ], 8, _hoisted_110), [
                                        [_vShow, _ctx.isEdit]
                                      ])
                                    ])
                                  ])
                                ], 512)), [
                                  [_vShow, item.isExpand]
                                ])
                              }), 128))
                            ], 64))
                          }), 128)),
                          _withDirectives(_createElementVNode("tr", null, [
                            _createElementVNode("td", _hoisted_112, [
                              _createElementVNode("p", null, [
                                (!_ctx.loading)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_113, "No data found"))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ], 512), [
                            [_vShow, _ctx.formData.relation_credit_note_item.length === 0]
                          ]),
                          _createElementVNode("tr", null, [
                            _createElementVNode("td", _hoisted_114, [
                              (_ctx.isEdit)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_115, [
                                    _createElementVNode("div", _hoisted_116, [
                                      _createElementVNode("div", _hoisted_117, [
                                        _createElementVNode("div", _hoisted_118, [
                                          _createElementVNode("div", _hoisted_119, [
                                            _createElementVNode("label", _hoisted_120, _toDisplayString(_ctx.t("orderRequest.orderNotes")), 1),
                                            _createVNode(_component_el_form_item, { prop: "overall_notes" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_el_input, {
                                                  modelValue: _ctx.formData.overall_notes,
                                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.overall_notes) = $event)),
                                                  placeholder: _ctx.t('common.plsEnter'),
                                                  class: "mw-500px",
                                                  clearable: "",
                                                  type: "textarea"
                                                }, null, 8, ["modelValue", "placeholder"])
                                              ]),
                                              _: 1
                                            })
                                          ])
                                        ])
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("td", _hoisted_121, [
                              _createElementVNode("div", _hoisted_122, [
                                _createElementVNode("div", _hoisted_123, _toDisplayString(_ctx.t("orderRequest.subtotalExclTax")) + ": ", 1),
                                (_ctx.formData.shipping_tax_rate !== 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_124, [
                                      _createElementVNode("div", _hoisted_125, [
                                        _createElementVNode("span", null, _toDisplayString(_ctx.t("orderRequest.shippingCharge")) + ":", 1),
                                        _createElementVNode("span", _hoisted_126, _toDisplayString(_ctx.t("orderRequest.taxApplied", [
                                      _ctx.formData.shipping_tax_rate,
                                    ])), 1)
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getVatArr, (item, index) => {
                                  return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(_ctx.t("order.tax")) + " " + _toDisplayString(item.tax_percent + "%") + ": ", 1))
                                }), 128)),
                                (_ctx.formData.shipping_tax_rate === 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_127, [
                                      _createElementVNode("div", _hoisted_128, [
                                        _createElementVNode("span", null, _toDisplayString(_ctx.t("orderRequest.shippingCharge")) + ":", 1),
                                        _createElementVNode("span", _hoisted_129, _toDisplayString(_ctx.t("orderRequest.taxApplied", [
                                      _ctx.formData.shipping_tax_rate,
                                    ])), 1)
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_130, _toDisplayString(_ctx.t("orderRequest.totalAmount")) + ": ", 1)
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_131, [
                              _createElementVNode("div", _hoisted_132, [
                                _createElementVNode("div", _hoisted_133, _toDisplayString(_ctx.$currency.currency(
                                  _ctx.getAmountSubTotal,
                                  2,
                                  ",",
                                  ".",
                                  "€ "
                                )), 1),
                                (_ctx.formData.shipping_tax_rate !== 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_134, [
                                      _createElementVNode("div", _hoisted_135, [
                                        _createElementVNode("div", _hoisted_136, [
                                          _withDirectives(_createElementVNode("span", _hoisted_137, [
                                            _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/art/art005.svg" })
                                          ], 512), [
                                            [_vShow, _ctx.isEdit]
                                          ]),
                                          _createElementVNode("span", null, _toDisplayString(_ctx.$currency.currency(
                                      _ctx.getOrderItemAmountTotal(
                                        1,
                                        Number(_ctx.formData.shipping_charges),
                                        0,
                                        _ctx.CurrencyType.Amount,
                                        _ctx.formData.shipping_tax_rate,
                                        false
                                      ) +
                                        _ctx.getOrderItemVatTotal(
                                          1,
                                          Number(_ctx.formData.shipping_charges),
                                          0,
                                          _ctx.CurrencyType.Amount,
                                          _ctx.formData.shipping_tax_rate,
                                          false
                                        ),
                                      2,
                                      ",",
                                      ".",
                                      "€ "
                                    )), 1)
                                        ]),
                                        _hoisted_138
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getVatArr, (item, index) => {
                                  return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(_ctx.$currency.currency(
                                  _ctx.getVatItemTotal(item.tax_percent),
                                  2,
                                  ",",
                                  ".",
                                  "€ "
                                )), 1))
                                }), 128)),
                                (_ctx.formData.shipping_tax_rate === 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_139, [
                                      _createElementVNode("div", _hoisted_140, [
                                        _createElementVNode("div", _hoisted_141, [
                                          _withDirectives(_createElementVNode("span", _hoisted_142, [
                                            _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/art/art005.svg" })
                                          ], 512), [
                                            [_vShow, _ctx.isEdit]
                                          ]),
                                          _createElementVNode("span", null, _toDisplayString(_ctx.$currency.currency(
                                      _ctx.getOrderItemAmountTotal(
                                        1,
                                        Number(_ctx.formData.shipping_charges),
                                        0,
                                        _ctx.CurrencyType.Amount,
                                        _ctx.formData.shipping_tax_rate,
                                        false
                                      ) +
                                        _ctx.getOrderItemVatTotal(
                                          1,
                                          Number(_ctx.formData.shipping_charges),
                                          0,
                                          _ctx.CurrencyType.Amount,
                                          _ctx.formData.shipping_tax_rate,
                                          false
                                        ),
                                      2,
                                      ",",
                                      ".",
                                      "€ "
                                    )), 1)
                                        ]),
                                        _hoisted_143
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_144, _toDisplayString(_ctx.$currency.currency(
                                  _ctx.getOrderItemsTotal,
                                  2,
                                  ",",
                                  ".",
                                  "€ "
                                )), 1)
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])), [
                [_directive_loading, _ctx.loading]
              ]),
              _createElementVNode("div", _hoisted_145, [
                _withDirectives(_createElementVNode("button", {
                  disabled: _ctx.loading || _ctx.uploading,
                  class: "btn btn-light-success",
                  type: "button",
                  onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.verify && _ctx.verify(...args)))
                }, [
                  _withDirectives(_createElementVNode("span", null, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.t("common.pleaseWait")), 1),
                    _hoisted_147
                  ], 512), [
                    [_vShow, _ctx.loading]
                  ]),
                  _withDirectives(_createElementVNode("span", null, [
                    _createElementVNode("span", _hoisted_148, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr084.svg" })
                    ]),
                    _createElementVNode("span", null, _toDisplayString(_ctx.t("orderRequest.verify")), 1)
                  ], 512), [
                    [_vShow, !_ctx.loading]
                  ])
                ], 8, _hoisted_146), [
                  [_vShow, 
                _ctx.isEdit &&
                _ctx.formData.status === _ctx.InvoiceStatus.Pending &&
                !_ctx.isChangeData &&
                _ctx.isSameTotalAmount &&
                _ctx.formData.relation_credit_note_item.length !== 0
              ]
                ]),
                _withDirectives(_createElementVNode("button", {
                  disabled: _ctx.loading || _ctx.uploading,
                  class: "btn btn-primary",
                  type: "button",
                  onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
                }, [
                  _withDirectives(_createElementVNode("span", null, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.t("common.pleaseWait")), 1),
                    _hoisted_150
                  ], 512), [
                    [_vShow, _ctx.loading]
                  ]),
                  _withDirectives(_createElementVNode("span", null, [
                    _createElementVNode("span", _hoisted_151, [
                      _createVNode(_component_inline_svg_icon, { src: "media/svg/custom/submit.svg" })
                    ]),
                    _createElementVNode("span", null, _toDisplayString(_ctx.t("common.save")), 1)
                  ], 512), [
                    [_vShow, !_ctx.loading]
                  ])
                ], 8, _hoisted_149), [
                  [_vShow, _ctx.isEdit]
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ], 512),
    _createVNode(_component_add_product, {
      merchantId: Number(_ctx.formData.merchant),
      merchantMap: _ctx.options.merchantMap,
      onUpdateList: _ctx.updateProduct
    }, null, 8, ["merchantId", "merchantMap", "onUpdateList"]),
    _createVNode(_component_update_shipping_fee, {
      amount: _ctx.formData.shipping_charges,
      tax: _ctx.formData.shipping_tax_rate,
      taxArr: _ctx.formData.__show.taxRates,
      onUpdateList: _ctx.updateShippingFee
    }, null, 8, ["amount", "tax", "taxArr", "onUpdateList"])
  ], 64))
}